export class URLS_FACTORY {
	static URLS_PATHS = {
		HOME: 'home',
		ROOT: '/',
		FORGOT_PASSWORD: '/forgot-password',
		DASHBOARD: '/dashboard',
		USERS: 'users',
    CUSTOMERS: 'customers',
    GROUPS: 'groups',
    ORDERS: 'orders',
    PROFILE: 'profile',
    UPLOAD_TYPES: 'upload_types',
    ORDER_TYPES: 'order_types'
	}

	static URLS_FULL_PATHS = {
		FULL_LOGIN: URLS_FACTORY.URLS_PATHS.ROOT,
    FULL_DASHBOARD: URLS_FACTORY.URLS_PATHS.DASHBOARD,
		FULL_DASHBOARD_USERS: URLS_FACTORY.URLS_PATHS.DASHBOARD + "/" + URLS_FACTORY.URLS_PATHS.USERS,
    FULL_DASHBOARD_USER: URLS_FACTORY.URLS_PATHS.DASHBOARD + "/" + URLS_FACTORY.URLS_PATHS.USERS + "/",
    FULL_DASHBOARD_CUSTOMERS: URLS_FACTORY.URLS_PATHS.DASHBOARD + "/" + URLS_FACTORY.URLS_PATHS.CUSTOMERS,
    FULL_DASHBOARD_CUSTOMER: URLS_FACTORY.URLS_PATHS.DASHBOARD + "/" + URLS_FACTORY.URLS_PATHS.CUSTOMERS + "/",
    FULL_DASHBOARD_GROUPS: URLS_FACTORY.URLS_PATHS.DASHBOARD + "/" + URLS_FACTORY.URLS_PATHS.GROUPS,
    FULL_DASHBOARD_GROUP: URLS_FACTORY.URLS_PATHS.DASHBOARD + "/" + URLS_FACTORY.URLS_PATHS.GROUPS + "/",
    FULL_DASHBOARD_ORDERS: URLS_FACTORY.URLS_PATHS.DASHBOARD + "/" + URLS_FACTORY.URLS_PATHS.ORDERS,
    FULL_DASHBOARD_ORDER: URLS_FACTORY.URLS_PATHS.DASHBOARD + "/" + URLS_FACTORY.URLS_PATHS.ORDERS + "/",
    FULL_DASHBOARD_ORDER_STATS: URLS_FACTORY.URLS_PATHS.DASHBOARD + "/" + URLS_FACTORY.URLS_PATHS.ORDERS + "/_stats/",
    FULL_DASHBOARD_UPLOAD_TYPES: URLS_FACTORY.URLS_PATHS.DASHBOARD + "/" + URLS_FACTORY.URLS_PATHS.UPLOAD_TYPES,
    FULL_DASHBOARD_UPLOAD_TYPE: URLS_FACTORY.URLS_PATHS.DASHBOARD + "/" + URLS_FACTORY.URLS_PATHS.UPLOAD_TYPES + "/",
    FULL_DASHBOARD_ORDER_TYPES: URLS_FACTORY.URLS_PATHS.DASHBOARD + "/" + URLS_FACTORY.URLS_PATHS.ORDER_TYPES,
    FULL_DASHBOARD_ORDER_TYPE: URLS_FACTORY.URLS_PATHS.DASHBOARD + "/" + URLS_FACTORY.URLS_PATHS.ORDER_TYPES + "/",
		FULL_PROFILE: URLS_FACTORY.URLS_PATHS.DASHBOARD + "/" + URLS_FACTORY.URLS_PATHS.PROFILE
	}

  static getURL = (url, {
    user_id,
    customer_id,
    group_id,
    order_id,
    upload_type_id,
    order_type_id
  } = {}) => {
		switch (url){
			case URLS_FACTORY.URLS_FULL_PATHS.FULL_DASHBOARD_USER:
				return URLS_FACTORY.URLS_FULL_PATHS.FULL_DASHBOARD_USER + user_id;
      case URLS_FACTORY.URLS_FULL_PATHS.FULL_DASHBOARD_CUSTOMER:
        return URLS_FACTORY.URLS_FULL_PATHS.FULL_DASHBOARD_CUSTOMER + customer_id;
      case URLS_FACTORY.URLS_FULL_PATHS.FULL_DASHBOARD_GROUP:
        return URLS_FACTORY.URLS_FULL_PATHS.FULL_DASHBOARD_GROUP + group_id;
      case URLS_FACTORY.URLS_FULL_PATHS.FULL_DASHBOARD_ORDER:
        return URLS_FACTORY.URLS_FULL_PATHS.FULL_DASHBOARD_ORDER + order_id;
      case URLS_FACTORY.URLS_FULL_PATHS.FULL_DASHBOARD_ORDER_STATS:
        return URLS_FACTORY.URLS_FULL_PATHS.FULL_DASHBOARD_ORDER + order_id + "/stats";
      case URLS_FACTORY.URLS_FULL_PATHS.FULL_DASHBOARD_UPLOAD_TYPE:
        return URLS_FACTORY.URLS_FULL_PATHS.FULL_DASHBOARD_UPLOAD_TYPE + upload_type_id;
      case URLS_FACTORY.URLS_FULL_PATHS.FULL_DASHBOARD_ORDER_TYPE:
        return URLS_FACTORY.URLS_FULL_PATHS.FULL_DASHBOARD_ORDER_TYPE + order_type_id;
			default:
				return url;
		}
	}
}
